import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { MappedLink } from "@insite/content-library/Widgets/Header/MainNavigation";
import GridContainer, { GridContainerProps, GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle, GridWidths } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { navigationInteraction } from "@WhiteCap/Common/Utillities/CustomTracking";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";

export interface CategorySectionStyles {
    CategoryContainer: GridContainerProps;
    CategoryFirstGridItem: GridItemProps;
    CategorySecondGridItem: GridItemProps;
    leftMegaMenuItem: GridItemProps;
    leftMegaMenuLink: LinkPresentationProps;
    rightMegaMenuItem: GridItemProps;
    rightMegaMenuStaticLink: GridItemProps;
    rightMegaMenuLink: LinkPresentationProps;
    rightMegaMenuChildLink: LinkPresentationProps;
    PromoGridItem: GridItemProps;
    PromoOuterGridItem: GridItemProps;
    PromoImage: LazyImageProps;
    PromoImageDescription: LinkPresentationProps;
    PromoImageDetailInfo: TypographyProps;
    PromoButtonLink: LinkPresentationProps;
    PromoDangeouslyTag?: GridItemProps;
    ulList?: InjectableCss;
    ulContainer?: InjectableCss;
}

export const CategorySectionStyles: CategorySectionStyles = {
    CategoryContainer: {
        css: css`
            margin: 0px;
            max-width: 1280px !important;
            width: 100%;
            > ${GridOffset} {
                width: 100%;
                margin: auto;
                > ${GridWrapper} {
                    max-width: 1280px !important;
                    width: 100%;
                }
            }
        `,
    },
    CategoryFirstGridItem: {
        // width: 3,
        css: css`
            padding: 0px;
            max-width: 18.5%;
            flex-basis: 18.5%;
            flex-direction: column;
            overflow: visible;
            padding-left: 20px;
            min-height: 100%;
            &::-webkit-scrollbar {
                width: 4px;
            }

            &::-webkit-scrollbar-track {
                background: ${getColor("common.background")};
            }

            &::-webkit-scrollbar-thumb {
                background-color: ${getColor("text.accent")};
                border-radius: 7px;
            }
        `,
    },
    CategorySecondGridItem: {
        // width: 10,
        css: css`
            max-width: 81%;
            flex-basis: 81%;
            padding: 20px;
            height: 100%;
        `,
    },
    leftMegaMenuItem: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            width: 100%;
            padding: 5px 15px;
            height: 100%;
            border-bottom: 1px solid #858585;
            &:hover {
                a {
                    span {
                        color: black !important;
                    }
                }
            }
            ::after {
                color: #000;
                content: "\0025B8";
                position: absolute;
                right: 2px;
            }
        `,
    },
    leftMegaMenuLink: {
        css: css`
            span {
                color: inherit !important;
                font-size: 12px;
            }
        `,
    },
    rightMegaMenuItem: {
        css: css`
            border: 2px solid black;
            display: flex;
            flex-direction: column;
            /* max-height: 450px;
            height: 100%; */
            /* overflow: hidden auto; */
            min-height: 100%;
            max-height: 100vh;
            height: max-content;
            /* li {
                ::after {
                    color: #000;
                    content: "\0025B8";
                    position: absolute;
                    right: -15px;
                }
            } */
        `,
    },
    rightMegaMenuStaticLink: {
        css: css`
            color: ${getColor("text.main")};
            flex-basis: 100%;
            max-width: 100%;
            margin: 0 0 22px 0 !important;
            padding: 0px;
            font-weight: bold;
            cursor: pointer;
            ::after {
                color: #000;
                content: "\0025B8";
                position: absolute;
                right: -15px;
            }
            &:hover {
                text-decoration: underline;
            }
        `,
    },
    rightMegaMenuLink: {
        css: css`
            font-weight: bold;
            position: relative;
            > ${TypographyStyle} {
                color: ${getColor("text.main")};
                white-space: inherit;
                ::after {
                    color: #000;
                    content: "\0025B8";
                    position: absolute;
                    right: -12px;
                }
            }
            &:hover {
                span {
                    color: ${getColor("text.main")} !important;
                    text-decoration: underline;
                }
            }
        `,
    },
    rightMegaMenuChildLink: {
        css: css`
            font-weight: normal;
            > ${TypographyStyle} {
                text-indent: 20px;
                white-space: nowrap;
                display: inline;
                font-size: 12px;
                font-weight: 400;
                color: #000;
                &:hover {
                    color: #000 !important;
                    text-decoration: underline;
                }
            }
        `,
    },
    PromoGridItem: {
        css: css`
            max-width: 100%;
            flex-basis: 100%;
            flex-direction: column;
        `,
    },
    PromoOuterGridItem: {
        css: css`
            max-width: 100%;
            flex-basis: 100%;
            flex-direction: column;
        `,
    },
    PromoImage: {
        css: css`
            width: 200px;
            height: 200px;
        `,
    },
    PromoImageDescription: {},
    PromoImageDetailInfo: {
        css: css`
            color: ${getColor("text.main")};
        `,
    },
    PromoButtonLink: {},
    ulList: {
        css: css``,
    },
    ulContainer: {
        css: css`
            display: flex;
            overflow-x: auto;
            background: #ebebeb;
            height: 100%;
            left: 20.3125%;
            padding: 2.4rem;
            position: absolute;
            right: 0;
            top: 0;
            > ul {
                align-content: flex-start;
                align-items: flex-start;
                background-color: transparent;
                display: flex;
                flex-basis: auto;
                flex-flow: column;
                flex-wrap: wrap;
                justify-content: flex-start;
                width: 100%;
                > li {
                    text-align: left;
                    width: 33%;
                    margin-bottom: 5px;
                    padding: 0 3rem 0 1rem;
                }
            }
        `,
    },
};

const CategorySectionComponent = ({ link, onHandleClose }: { link: MappedLink; onHandleClose: Function }) => {
    const [activeChildIndex, setActiveChildIndex] = useState<number | null>(0);
    const [showRightSection, setShowRightSection] = useState<boolean>(false);

    const handleMouseEnter = (index: number, categoryName: string) => {
        setActiveChildIndex(index);
        setShowRightSection(true);
    };

    const handleMouseLeave = () => {
        setShowRightSection(false);
    };
    const redirectToLandingPage = (url: string) => {
        window.location.href = url;
        onHandleClose();
    };
    const styles = CategorySectionStyles;

    const sendDataLayerAndHandleClose = (navigationCategory: string, navigationClickText: string) => {
        navigationInteraction({
            event: 'navigation_interaction',
            navigation_category: `Categories - ${navigationCategory}`,
            navigation_click: navigationClickText
        })

        onHandleClose();
    }

    return (
        <>
            {link.children && link?.children?.length > 0 && (
                <GridContainer {...styles.CategoryContainer}>
                    <GridItem {...styles.CategoryFirstGridItem}>
                        {link.children!.map((child: MappedLink, childIndex: number) => (
                            <GridItem
                                className="Category-mega-menu-left-grid-item"
                                style={{
                                    backgroundColor: activeChildIndex === childIndex ? "#fc3" : "initial",
                                    cursor: "pointer",
                                    position: "relative",
                                }}
                                {...styles.leftMegaMenuItem}
                                width={(12 / link.numberOfColumns!) as GridWidths}
                                key={`left-grid-item_${childIndex}`}
                                onMouseOver={() => handleMouseEnter(childIndex, child.title)}
                                onMouseLeave={handleMouseLeave}
                                as="li"
                            >
                                <Link
                                    className="Category-mega-menu-left-link"
                                    {...styles.leftMegaMenuLink}
                                    href={child.url}
                                    data-category-name={`selectedCategoryName_${child.title}`}
                                    style={{
                                        color: activeChildIndex === childIndex ? "#fff" : "#000",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => sendDataLayerAndHandleClose(child.title, child.title)}
                                >
                                    {child.title}
                                </Link>
                            </GridItem>
                        ))}
                    </GridItem>
                    <GridItem
                        {...styles.CategorySecondGridItem}
                        className={`right-parent-grid-item ${showRightSection ? "show-right-section" : ""}`}
                    >
                        {link.children &&
                            link.children.map(
                                (child: MappedLink, childIndex: number) =>
                                    activeChildIndex === childIndex && (
                                        <StyledWrapper key={childIndex} {...styles.ulContainer}>
                                            {child.children && (
                                                <ul data-test-selector={`linksFor_${child.title}`} {...styles.ulList}>
                                                    {child.children.map((leafChild: MappedLink, index: number) => (
                                                        <li key={`secondLvl_${index}`}>
                                                            <Link
                                                                className="Category-mega-menu-right-link"
                                                                {...styles.rightMegaMenuLink}
                                                                href={leafChild.url}
                                                                data-test-selector={leafChild.title}
                                                                onClick={() => sendDataLayerAndHandleClose(child.title, leafChild.title)}
                                                            >
                                                                {leafChild.title}
                                                            </Link>
                                                            {leafChild.children && (
                                                                <ul data-test-selector={`linksFor_${leafChild.title}`}>
                                                                    {leafChild.children.map(
                                                                        (
                                                                            subLeafChild: MappedLink,
                                                                            subIndex: number,
                                                                        ) => (
                                                                            <li key={`thirdLvl_${subIndex}`}>
                                                                                <Link
                                                                                    className="Category-mega-menu-right-child-link"
                                                                                    {...styles.rightMegaMenuChildLink}
                                                                                    href={subLeafChild.url}
                                                                                    data-test-selector={
                                                                                        subLeafChild.title
                                                                                    }
                                                                                    onClick={() => sendDataLayerAndHandleClose(child.title, subLeafChild.title)}
                                                                                >
                                                                                    {subLeafChild.title}
                                                                                </Link>
                                                                            </li>
                                                                        ),
                                                                    )}
                                                                </ul>
                                                            )}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </StyledWrapper>
                                    ),
                            )}
                    </GridItem>
                </GridContainer>
            )}
        </>
    );
};

export default CategorySectionComponent;
